import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-comment-dialogue',
  templateUrl: './comment-dialogue.component.html',
  styleUrls: ['./comment-dialogue.component.scss'],
})
export class CommentDialogueComponent implements OnInit {
  managerComment: string = '';
  showErrorMsg = false;
  constructor(private matDialogRef: MatDialogRef<CommentDialogueComponent>, @Inject(MAT_DIALOG_DATA) public matDialogData: any) { }

  ngOnInit() { }

  closeModal() {
    this.showErrorMsg = false;
    if (this.matDialogData == 'Rejected' && !this.managerComment) {
      this.showErrorMsg = true;
      return;
    }
    this.matDialogRef.close(this.managerComment);
  }
}
